import { ReactNode } from 'react';
import './styles/PageHeader.scss';

export default function PageHeader({ title, subtitle, right }: { title: string; subtitle?: string; right?: ReactNode }) {
    return (
        <div className="pageHeader">
            <div className="phText">
                <h1>{title}</h1>
                {subtitle && <p>{subtitle}</p>}
            </div>
            {right && <div className="phRight">{right}</div>}
        </div>
    );
}
